import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EmpresaListarModule } from './empresa-listar/empresa-listar.module';
import { EmpresaInserirModule } from './empresa-inserir/empresa-inserir.module';
import { EmpresaDetalharModule } from './empresa-detalhar/empresa-detalhar.module';
import { EmpresaEditarModule } from './empresa-editar/empresa-editar.module';


@NgModule({
    imports: [RouterModule.forChild([        
        { path: '', data: { breadcrumb : '' }, loadChildren: () => EmpresaListarModule },
        { path: 'inserir', data: { breadcrumb : 'Inserir' }, loadChildren: () => EmpresaInserirModule },                
        { path: 'detalhar', data: { breadcrumb : 'Detalhar' }, loadChildren: () => EmpresaDetalharModule },                
        { path: 'editar', data: { breadcrumb : 'Editar' }, loadChildren: () => EmpresaEditarModule },                
    
    ])],
    exports: [RouterModule]
})
export class EmpresaAppRoutingModule { }